export default class ActualizarAnioCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idAnioCurso, payload) {
    try {
      const result = await this.#repository.actualizarAnioCurso(idAnioCurso, payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
